import React from "react";
import { SingleProduc } from "../../Components/SingleProduct/SingleProduct";

const SingleProduct = () => {
  return (
    <div>
      <SingleProduc />
    </div>
  );
};

export default SingleProduct;
